import { IClientGridRow } from '@/Interfaces/Client.interface';
import ExportIcon from '@/components/Icons/ExportIcon';
import { useAppDispatch } from '@/store/hooks';
import { setSelectedClient } from '@/store/slices/clients.slice';
import { Button, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useCallback } from 'react';

const ViewClientButton = styled(Button)(({ theme }) => ({
  minHeight: '29px',
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: theme.shape.borderRadius * 4,
  textWrap: 'nowrap',
  maxWidth: '200px',
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(1),
  },
  '& .MuiButton-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

const ActionsCell = ({ row }: GridRenderCellParams<IClientGridRow>) => {
  const dispatch = useAppDispatch();

  const selectRow = useCallback(() => {
    if (!row) return;
    dispatch(setSelectedClient(row));
  }, [dispatch, row]);

  return (
    <div className='flex justify-center'>
      <ViewClientButton
        startIcon={<ExportIcon className='w-[11px]' />}
        variant='outlined'
        color='primary'
        onClick={selectRow}
        aria-label={`View details for ${row?.name || 'client'}`}
      >
        View
      </ViewClientButton>
    </div>
  );
};

export default ActionsCell;
